import React, { useState } from 'react'
import * as sections from './offer-sections'
import { useAppSelector } from 'src/app/hooks'
import { userSaleOffersSelector } from 'src/features'

const OffersPageContent: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { data: ctOffers } = useAppSelector(userSaleOffersSelector)

  return <div className='fade-animation'>
    {/* Page Header */}
    <sections.OffersPageHeader
      handleButtonClick={() => setIsModalVisible(true)}
    />

    {/* Climatetrade Offers */}
    {ctOffers.length > 0 && <sections.ClimatetradeOffersCard />}

    {/* Market Offers */}
    <sections.MarketOffersCard />

    {/* Proposal Modal */}
    <sections.RequestForProposalModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
    />
  </div>
}

export default OffersPageContent
